import {combineReducers} from 'redux';
import templates from './templates';
import filters from './filters';

export default combineReducers({ templates, filters });